export const ADDITIONAL_PAYMENTS_DETAILS_SECTION_COPY = {
  title: "Additional payments details",
  action: "Edit additional payments",
};
